import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Financial Data API
export const financialAPI = {
  getLatest: async () => {
    const response = await axios.get(`${API_BASE_URL}/financial/latest`);
    return response.data;
  },
  
  getByYear: async (year) => {
    const response = await axios.get(`${API_BASE_URL}/financial/year/${year}`);
    return response.data;
  },
  
  getAll: async () => {
    const response = await axios.get(`${API_BASE_URL}/financial/all`);
    return response.data;
  },
  
  createOrUpdate: async (data) => {
    const response = await axios.post(`${API_BASE_URL}/financial`, data);
    return response.data;
  },
  
  uploadExcel: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_BASE_URL}/financial/upload-excel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};

// Stories API
export const storiesAPI = {
  getAll: async () => {
    const response = await axios.get(`${API_BASE_URL}/stories`);
    return response.data;
  },
  
  create: async (story) => {
    const response = await axios.post(`${API_BASE_URL}/stories`, story);
    return response.data;
  },
  
  update: async (id, story) => {
    const response = await axios.put(`${API_BASE_URL}/stories/${id}`, story);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/stories/${id}`);
    return response.data;
  }
};

// Company API
export const companyAPI = {
  get: async () => {
    const response = await axios.get(`${API_BASE_URL}/company`);
    return response.data;
  },
  
  update: async (data) => {
    const response = await axios.put(`${API_BASE_URL}/company`, data);
    return response.data;
  }
};

// Attendance API
export const attendanceAPI = {
  getLatest: async () => {
    const response = await axios.get(`${API_BASE_URL}/attendance/latest`);
    return response.data;
  },
  
  getByYear: async (year) => {
    const response = await axios.get(`${API_BASE_URL}/attendance/year/${year}`);
    return response.data;
  }
};
